import {
  Button,
  makeStyles,
  Menu,
  ListSubheader,
  MenuItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Fab,
  SvgIcon,
  Checkbox,
  IconButton,
  Switch,
  FormControl,
  FormControlLabel,
} from "@material-ui/core";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import Sheet from "../../comps/sheet/Sheet";
import SheetBody from "../../comps/sheet/SheetBody";
import SheetFooter from "../../comps/sheet/SheetFooter";
import SheetHead from "../../comps/sheet/SheetHead";
import SheetHeadTitle from "../../comps/sheet/SheetHeadTitle";
import SheetSection from "../../comps/sheet/SheetSection";
import CheckIcon from "@material-ui/icons/Check";
import SaveOutlinedIcon from "@material-ui/icons/SaveOutlined";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { ReactComponent as VsIcon } from "../../comps/assets/vs.svg";
import { green } from "@material-ui/core/colors";
import {
  Participant,
  Player,
  ReduxState,
  Stat,
  StatPlayerVsProps,
} from "../../config/types/types";
import { AdjustmentsProps } from "../../config/types/adjustments.interface";
import {
  WebsocketProps,
  wsContext,
} from "../../config/websocket/WebsocketProvider";
import SheetHeadSub from "../../comps/sheet/SheetHeadSub";
import TextField from "../../comps/textfield/TextField";
import blobber from "@utils/blobber";
import toast from "react-hot-toast";
import useSettings from "@lib/useSettings";

const mcs = makeStyles((theme) => ({
  select: {
    maxHeight: 300,
    // width: 200,
  },
  listsubheader: {
    backgroundColor: "#9c27b0",
    color: "#fff",
  },
  player2: {
    flexDirection: "row-reverse",
    backgroundColor: "rgba(244, 67, 54, .10)!important",
    "& .logo": {
      marginLeft: 20,
    },
    "& .info": {
      "& .ign": { textAlign: "right" },
      "& .name": {
        textAlign: "right",
      },
    },
  },
  player: {
    margin: theme.spacing(2, 0),
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(5),
    backgroundColor: "rgba(156, 39, 176, .1)",
    borderRadius: 10,
    "& .logo": {
      height: 85,
      width: 85,
      borderRadius: 3,
      marginRight: 20,
      backgroundSize: "contain",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    },
    "& .info": {
      "& .ign": {
        fontWeight: "bold",
        fontSize: "1.2rem",
      },
      "& .name": {
        fontSize: "1rem",
      },
    },
  },
  headWrapper: {
    display: "flex",
    alignItems: "center",
    "& h5": {
      flex: 1,
    },
  },
  fabWrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  vsSection: {
    display: "flex",
    flexDirection: "column",
  },

  vs: { alignSelf: "center", padding: "10px 0", fontWeight: "bold" },

  statAdd: {
    marginTop: 40,
    display: "flex",
    "& .input": {
      marginRight: theme.spacing(2),
    },
  },
  stats: {
    alignSelf: "center",
    display: "flex",
    flexDirection: "column",
    "& .stat": {
      display: "flex",
      alignItems: "center",
      "& > *": {
        marginRight: 10,
      },
    },
  },
  playerSettings: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    alignItems: "center",
    justify: "center",
    gap: 20,
    margin: theme.spacing(4, 0),
  },
}));

const StatsPlayerVsPlayer = () => {
  const classes = mcs();
  const { tournament, stat_player_vs } = useSelector(
    (state: ReduxState) => state.live
  );

  const [statInput, setStatInput] = React.useState<string>("Kills");

  const ws = React.useContext(wsContext);
  const [anchorEl, setAnchorEl] = React.useState<any>(null);
  const [anchorEl2, setAnchorEl2] = React.useState<any>(null);
  const [form, setForm] = React.useState<StatPlayerVsProps>({
    player1: { name: "", ign: "", stats: [] },
    player2: { name: "", ign: "", stats: [] },
    player1_settings: {
      scale: 0,
      x: 0,
      y: 0,
      flip_x: false,
    },
    player2_settings: {
      scale: 0,
      x: 0,
      y: 0,
      flip_x: false,
    },
    stat_names: [],
  });

  React.useEffect(() => {
    if (stat_player_vs) {
      setForm(stat_player_vs);
    }
  }, [stat_player_vs, setForm]);

  const save = () => {
    ws.setLiveSettings({ stat_player_vs: form });
  };

  const addStat = () => {
    setForm({
      ...form,
      stat_names: [...form.stat_names, statInput],
      player1: {
        ...form.player1,
        stats: [
          ...form.player1.stats,
          { stat_name: statInput, stat_value: "", isOn: true },
        ],
      },
      player2: {
        ...form.player2,
        stats: [
          ...form.player2.stats,
          { stat_name: statInput, stat_value: "", isOn: true },
        ],
      },
    });
  };

  const handleStatChange =
    (player: string, i: number) =>
    ({
      currentTarget: { name, value },
    }: React.ChangeEvent<HTMLInputElement>) => {
      setForm({
        ...form,
        [player]: {
          ...form[player],
          stats: form[player].stats.map((s: Stat, ii: number) =>
            i === ii ? { ...s, [name]: value } : s
          ),
        },
      });
    };
  const removeStat = (index: number) => () => {
    setForm({
      ...form,
      player1: {
        ...form.player1,
        stats: form.player1.stats.filter((s, i) => i !== index),
      },
      player2: {
        ...form.player2,
        stats: form.player2.stats.filter((s, i) => i !== index),
      },
      stat_names: form.stat_names.filter((s, i) => i !== index),
    });
  };

  const adjustSettings =
    (player: keyof StatPlayerVsProps) =>
    ({
      currentTarget: { name, valueAsNumber },
    }: React.ChangeEvent<HTMLInputElement>) => {
      setForm({
        ...form,
        [player]: {
          ...(form[player] as AdjustmentsProps),
          [name]: valueAsNumber,
        },
      });
    };

  return (
    <Sheet>
      <SheetHead
        icon={
          <SvgIcon fontSize="large">
            <VsIcon />
          </SvgIcon>
        }
      >
        <div className={classes.headWrapper}>
          <div style={{ flex: 1 }}>
            <SheetHeadTitle>Player Vs Player</SheetHeadTitle>
            <SheetHeadSub>
              goes to{" "}
              <a
                href="http://localhost:3001/playervsplayer"
                style={{ color: "#fff", textDecoration: "none" }}
              >
                /playervsplayer
              </a>
            </SheetHeadSub>
          </div>
          <div className={classes.fabWrapper}>
            <Fab
              color="primary"
              onClick={save}
              disabled={stat_player_vs === form}
            >
              {stat_player_vs === form ? (
                <CheckIcon fontSize="large" />
              ) : (
                <SaveOutlinedIcon fontSize="large" />
              )}
            </Fab>
          </div>
        </div>
      </SheetHead>
      <SheetBody>
        <div style={{ display: "flex" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={({ currentTarget }) => setAnchorEl(currentTarget)}
          >
            Select Player 1
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            classes={{ paper: classes.select }}
          >
            {SelectionItems(
              tournament?.participants ?? [],
              form,
              setForm,
              ws,
              "player1",
              () => setAnchorEl(null)
            ).map((item: any) => item)}
          </Menu>
          <Button
            variant="contained"
            color="secondary"
            style={{ backgroundColor: "#e53935", marginLeft: 15 }}
            onClick={({ currentTarget }) => setAnchorEl2(currentTarget)}
          >
            Select Player 2
          </Button>
          <Menu
            anchorEl={anchorEl2}
            open={Boolean(anchorEl2)}
            onClose={() => setAnchorEl2(null)}
            classes={{ paper: classes.select }}
          >
            {SelectionItems(
              tournament?.participants ?? [],
              form,
              setForm,
              ws,
              "player2",
              () => setAnchorEl2(null)
            ).map((item: any) => item)}
          </Menu>
        </div>
        <SheetSection className={classes.vsSection}>
          <div className={classes.player}>
            <div
              className="logo"
              style={{ backgroundImage: `url("${form.player1.team?.logo}")` }}
            ></div>
            {form.player1.photo_main && (
              <div
                className="logo"
                style={{ backgroundImage: `url("${form.player1.photo_main}")` }}
              ></div>
            )}
            <div className="info">
              <div className="ign">{form.player1.ign}</div>
              <div className="name">{form.player1.name}</div>
            </div>
          </div>
          <div className={classes.playerSettings}>
            <TextField
              name="x"
              label="Horizontal Offset"
              value={form.player1_settings?.x}
              type="number"
              inputProps={{ step: 5 }}
              onChange={adjustSettings("player1_settings")}
            />
            <TextField
              name="scale"
              label="scale multiplyer"
              value={form.player1_settings?.scale}
              type="number"
              inputProps={{ step: 1 }}
              onChange={adjustSettings("player1_settings")}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={form.player1_settings?.flip_x}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setForm({
                      ...form,
                      player1_settings: {
                        ...(form.player1_settings as AdjustmentsProps),
                        flip_x: e.currentTarget.checked,
                      },
                    })
                  }
                  color="primary"
                />
              }
              label="Flip Horizontally"
            />
          </div>
          <div className={classes.stats}>
            {form.stat_names?.map((stat, i) => (
              <div className="stat" key={i}>
                <Checkbox
                  style={{ paddingTop: 10 }}
                  checked={
                    form.player1?.stats[i]?.isOn && form.player2?.stats[i]?.isOn
                  }
                  onChange={() =>
                    setForm({
                      ...form,
                      player1: {
                        ...form.player1,
                        stats: form.player1.stats.map((s, ii) =>
                          i === ii ? { ...s, isOn: !s.isOn } : s
                        ),
                      },
                      player2: {
                        ...form.player2,
                        stats: form.player2.stats.map((s, ii) =>
                          i === ii ? { ...s, isOn: !s.isOn } : s
                        ),
                      },
                    })
                  }
                />
                <TextField
                  value={form.player1.stats[i].stat_value}
                  name="stat_value"
                  size="small"
                  onChange={handleStatChange("player1", i)}
                  align="right"
                  disabled={!form.player1.stats[i].isOn}
                  inputProps={{
                    style: {
                      textAlign: "right",
                      backgroundColor: "rgba(156, 39, 176, .1)",
                    },
                  }}
                />
                <div
                  style={{ paddingTop: 10, width: 100, textAlign: "center" }}
                >
                  {stat}
                </div>
                <TextField
                  value={form.player2.stats[i].stat_value}
                  name="stat_value"
                  size="small"
                  disabled={!form.player2.stats[i].isOn}
                  inputProps={{
                    style: {
                      backgroundColor: "rgba(244, 67, 54, .10)",
                    },
                  }}
                  onChange={handleStatChange("player2", i)}
                />
                <IconButton onClick={removeStat(i)}>
                  <DeleteForeverIcon />
                </IconButton>
              </div>
            ))}
          </div>

          <div className={classes.playerSettings}>
            <TextField
              name="x"
              label="Horizontal Offset"
              value={form.player2_settings?.x}
              type="number"
              inputProps={{ step: 5 }}
              onChange={adjustSettings("player2_settings")}
            />
            <TextField
              name="scale"
              label="scale multiplyer"
              value={form.player2_settings?.scale}
              type="number"
              inputProps={{ step: 1 }}
              onChange={adjustSettings("player2_settings")}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={form.player2_settings?.flip_x}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setForm({
                      ...form,
                      player2_settings: {
                        ...(form.player2_settings as AdjustmentsProps),
                        flip_x: e.currentTarget.checked,
                      },
                    })
                  }
                  color="primary"
                />
              }
              label="Flip Horizontally"
            />
          </div>
          <div className={classes.player + " " + classes.player2}>
            <div
              className="logo"
              style={{ backgroundImage: `url("${form.player2.team?.logo}")` }}
            ></div>
            {Boolean(form.player1.photo_main) && (
              <div
                className="logo"
                style={{ backgroundImage: `url("${form.player2.photo_main}")` }}
              ></div>
            )}
            <div className="info">
              <div className="ign">{form.player2.ign}</div>
              <div className="name">{form.player2.name}</div>
            </div>
          </div>
        </SheetSection>
        <div className={classes.statAdd}>
          <TextField
            value={statInput}
            label="Stat name"
            className="input"
            size="small"
            onChange={({ currentTarget: { value } }) => setStatInput(value)}
          />
          <Button variant="outlined" onClick={addStat}>
            Add Stat
          </Button>
        </div>
      </SheetBody>
      <SheetFooter>
        This is different from the player displayed in lower thirds
      </SheetFooter>
    </Sheet>
  );
};

const SelectionItems = (
  participants: Participant[],
  form: StatPlayerVsProps,
  setForm: React.Dispatch<React.SetStateAction<StatPlayerVsProps>>,
  ws: WebsocketProps,
  player: string,
  onClose: () => void
) => {
  const [loading, set] = useState(false);
  const classes = mcs();
  let list: any[] = [];
  const { preloadImages } = useSettings();
  participants
    .filter((team) => Boolean(team?.players?.length))
    .forEach((team) => {
      list = [
        ...list,
        <ListSubheader key={team.id} className={classes.listsubheader}>
          {team.display_name}
        </ListSubheader>,
      ];

      function selectPlayer(p: Player) {
        return async () => {
          set(true);
          const teamBanner = preloadImages
            ? blobber(team.university_banner ?? "", true)
            : team.university_banner;
          const photo_main = preloadImages
            ? blobber(p.photo_main ?? "", true)
            : p.photo_main;

          const promise = Promise.all([teamBanner, photo_main]);
          toast.promise(promise, {
            loading: "Loading images...",
            error: (err) => err.message,
            success: "Done!",
          });

          promise
            .then(([teamBanner, photo_main]) => {
              const newTeam: Participant = {
                ...team,
                university_banner_base64: teamBanner ?? "",
              };
              const newData = {
                ...p,
                photo_main: photo_main ?? "",
                team: newTeam,
              };
              setForm((state) => ({
                ...state,
                [player]: {
                  ...newData,
                  stats: [...state[player]?.stats],
                },
              }));
              set(false);
              onClose();
            })
            .catch(console.error);
        };
      }
      team.players?.forEach((p) => {
        list = [
          ...list,
          <MenuItem
            button
            dense
            key={p.ign}
            onClick={selectPlayer(p)}
            disabled={loading}
          >
            <ListItemAvatar>
              <Avatar src={p.photo_main} />
            </ListItemAvatar>
            <ListItemText>{p.ign}</ListItemText>
          </MenuItem>,
        ];
      });
    });
  return list;
};

export default StatsPlayerVsPlayer;
